'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'carpool';
var width = 512;
var height = 512;
var aliases = ["car-people"];
var unicode = 'e69c';
var svgPathData = ['M0 416l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32-96 0zM114.7 224l122.5 0c-6.6-18.6-24.4-32-45.3-32l-32 0c-20.9 0-38.7 13.4-45.3 32zM136 128a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm138.7 96l122.5 0c-6.6-18.6-24.4-32-45.3-32l-32 0c-20.9 0-38.7 13.4-45.3 32zM296 128a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM416 416l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32-96 0z', 'M107.1 101.8L80.6 224 431.4 224 404.9 101.8C400.1 79.7 380.6 64 358 64L154 64c-22.6 0-42.1 15.7-46.9 37.8zM29.2 234.3l3.3-15.4 27.7-127.3C69.8 47.5 108.9 16 154 16L358 16c45.2 0 84.2 31.5 93.8 75.6l27.7 127.3 3.3 15.4C500.4 245.7 512 265.5 512 288l0 128-512 0 0-128c0-22.5 11.6-42.3 29.2-53.7zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarpool = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;